export default __webpack_public_path__ + "static/media/Background_00122.d49efe41.png";